import styled from 'styled-components'

const ToolBar = styled.div`
  padding: 16px 24px 0 24px;
  display: flex;
  background-color: var(--Grey100);
  height: 84px;
  :hover {
    box-shadow: 0 4px 8px 0 rgba(73, 83, 89, 0.16);
  }
`
const ReadableToolBar = styled(ToolBar)`
  height: unset;
  :hover {
    box-shadow: unset;
  }
  @media print {
    display: none;
  }
`
const TitleHolder = styled.div`
  text-align: center;
  background-color: #fff;
`
const Title = styled.label`
  text-align: left;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--Text700);
`
const ReadOnlyTitleHolder = styled.div`
  padding: 16px 24px;
  display: flex;
  background-color: var(--Grey100);
`
const ReadOnlyTitle = styled.div`
  width: 100%;
  text-align: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 500;
  display: flex;
  line-height: 1.2;
  color: var(--Text700);
`
const VersionTitle = styled.label`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--Text700);
`
const VersionBody = styled.label`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--Text500);
  margin-bottom: 16px;
  margin-top: 4px;
`
const Body = styled.div`
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.75;
  color: var(--Text500);
  margin-top: 16px;
`
const EditorHolder = styled.div`
  // padding: 16px;
  background-color: #fff;
  // min-height: 410px;
  // min-height: 100vh;
  max-width: 800px;
  margin: auto;
  margin-top: 54px;
  @media (max-width: 600px) {
    margin-top: 0;
  }
`

const ReadOnlyEditorHolder = styled(EditorHolder)`
  height: 64vh;
  overflow: auto;
  @media print {
    height: unset;
    overflow: unset;
  }
`

const VersionHolder = styled.div`
  cursor: pointer;
  padding: 16px 24px 0 24px;
  display: flex;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 8px;
  width: 480px;
  height: 78px;
  :hover {
    box-shadow: 0 4px 8px 0 rgba(73, 83, 89, 0.16);
  }
  @media(max-width:600px){
    width: calc(100vw - 32px);
  }
`
const PreviewToolbar = styled.div`
  padding: 16px 24px 0 24px;
  display: flex;
  justify-content: space-between;
  background-color: #eceff1;
  height: 84px;
  :hover {
    box-shadow: 0 4px 8px 0 rgba(73, 83, 89, 0.16);
  }
  
  @media only screen and (max-width:600px){
    flex-direction: column;
    height: auto;
    padding: 8px 16px;
  }
  @media only screen and (min-width: 500px) {
    flex-direction: row;
  }
`
const ToolContainer = styled.div`
  display: flex;
  margin-top: 9.7px;
`
const ToolInfo = styled.span`
  margin-left: 4px;
  color: rgba(13, 21, 54, 0.65);
  margin-right: 16px;
  font-weight: bold;
`
const ActionButtonDiv = styled.div`
  cursor: pointer;
  margin-left: auto;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: solid 2px var(--Azure500);
  width: 95px;
  height: 36px;
  text-align: center;
  justify-content: center;
`
const DraftButtonDiv = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: solid 2px var(--Azure500);
  // width: 151px;
  // height: 36px;
  text-align: center;
  justify-content: center;
`
const Time = styled.div`
  color: rgba(13, 21, 54, 0.4);
  font-weight: 500;
  font-size: 14px;
  margin-left: auto;
  display: flex;
  align-items: center;
`
const WordCount = styled(Time)``
const AddAnotherCTA = styled.span`
  font-size: 16px;
  font-weight: 600;
  margin-left: 4px;
  line-height: 1.5;
  color: var(--Azure500);
`
const EditorToolButton = styled(AddAnotherCTA)`
  border: 1px solid var(--Azure500);
  cursor: pointer;
  margin-right: 16px;
  border-radius: 50%;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
`
const CloseReadableEditor = styled(AddAnotherCTA)`
  cursor: pointer;
  margin-left: 15px;
`
const PrintReadableEditor = styled(AddAnotherCTA)`
  cursor: pointer;
  margin-left: auto;
`
const Spacer = styled.div`
  height: 40px;
`
const EditAnotherCTA = styled.span`
  font-size: 14px;
  font-weight: 600;
  margin-left: 4px;
  line-height: 1.43;
  color: var(--Azure500);
  padding: 0 16px;
  @media(max-width: 600px){
    padding: 8px;
  }
`
const PublishButton = styled.button`
  cursor: pointer;
  display: flex;
  height: 36px;
  width: 100px;
  border: none;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  border-radius: 4px;
  background-color: var(--Azure500);
`
const UpdateButton = styled.button`
  cursor: pointer;
  margin-left: auto;
  display: flex;
  height: 36px;
  width: 100px;
  border: none;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  border-radius: 4px;
  background-color: var(--Azure500);
`
const InputTitle = styled.input`
  padding: 0 16px 0 16px;
  border: none;
  outline: none;
  width: 800px;
  text-align: left;
  height: 60px;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--Text700);
`
const Tool = styled.span`
  display: flex;
  cursor: pointer;
`
const PublishLabel = styled.label`
  cursor: pointer;
  margin-left: 4px;
`
const RestoreButton = styled.button`
  cursor: pointer;
  display: flex;
  // height: 36px;
  // width: 88px;
  border: none;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: var(--Dove);
  border-radius: 4px;
  background-color: var(--Azure500);
  margin-left: 4px;
  padding: 0 16px;
  @media(max-width: 600px){
    padding: 8px;
  }
`
const VersionRestoreInfo = styled.label`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  color: var(--Text300);
`
const VersionRestore = styled.label`
  font-size: 20px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--Text500);
`
const Date = styled.label`
  color: rgba(13, 21, 54, 0.65);
  font-size: 20px;
  font-weight: 500;
`
const VersionContainer = styled.div`
  margin-top: 16px;
`
const EditorContainer = styled.div.attrs(props => ({
  className: "notranslate",
  translate: props.translate,
}))`
  padding: 0;
  // padding: 0 16px 0 16px;
  // width: 800px;
  max-width: 800px;
  // height: 58vh;
  min-height: 550px;
  font-size: 16px;
  margin: auto;
  font-weight: 500;
  line-height: 1.75;
  color: var(--Text500);
  // overflow: scroll; 
  
  .tox-toolbar.tox-toolbar--scrolling, .tox-toolbar__primary {
    background-color: var(--Grey300) !important;
    justify-content: flex-end;
  }

  // @media (max-width: 600px) {
  //   padding: 0;
  // }
`
const ReadOnlyEditorContainer = styled(EditorContainer)`
  font-size: ${({ fontSize }) => fontSize || '16px'};
  line-height: 2;
  width: unset;
  padding: 0;
  height: 58vh;
  // overflow: scroll;
  @media (max-width: 600px) {
    width: 100%;
    padding: 0;
    // height: 85vh;
  }
  @media print {
    height: unset;
    overflow: unset;
  }
`

export {
  EditorContainer,
  ReadOnlyEditorContainer,
  CloseReadableEditor,
  PrintReadableEditor,
  TitleHolder,
  Title,
  VersionTitle,
  VersionBody,
  Body,
  EditorHolder,
  VersionHolder,
  PreviewToolbar,
  ToolContainer,
  ToolInfo,
  ActionButtonDiv,
  DraftButtonDiv,
  Time,
  ReadOnlyTitle,
  ReadOnlyTitleHolder,
  AddAnotherCTA,
  EditorToolButton,
  EditAnotherCTA,
  PublishButton,
  UpdateButton,
  VersionContainer,
  Date,
  VersionRestore,
  VersionRestoreInfo,
  RestoreButton,
  PublishLabel,
  Tool,
  InputTitle,
  ToolBar,
  ReadableToolBar,
  Spacer,
  WordCount,
  ReadOnlyEditorHolder
}